module.exports = __webpack_public_path__ + "static/benefits-3-2e3d4eaed8326c6001588121a8a8d2eb.png";